import { otherSlot } from './types.js';
export function emit(t, event) {
    t.s.events.push(event);
}
export function mech(t, slot) {
    return t.s.mechs[slot];
}
export function defOf(t, slot) {
    return t.ctx.defs[slot];
}
export function nextId(t) {
    return t.s.nextId++;
}
/** True while damage and abilities are allowed (live play or sudden death). */
export function isLive(t) {
    return t.s.flow.phase === 'live' || t.s.flow.phase === 'suddenDeath';
}
/** True when this step is a client prediction: nothing here may decide damage. */
export function predicting(t) {
    return t.prediction !== undefined && t.prediction !== null;
}
/** The enemy pose a shooter's instant attacks resolve against (rewound when compensating). */
export function targetPose(t, shooter) {
    return t.rewound?.[shooter] ?? mech(t, otherSlot(shooter)).body;
}
//# sourceMappingURL=tick.js.map